import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  dateLabel: {
    fontWeight: 600,
    minWidth: 40,
    color: theme.palette.primary.main,
  },
  nameLabel: {
    flex: 1,
    marginLeft: 12,
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
  },
  customChip: {
    height: 22,
    fontSize: "0.7rem",
  },
  switchGroup: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  switchLabel: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
  },
}));

const HolidayRow = ({ holiday, onToggleActive, onToggleCloseTicket }) => {
  const classes = useStyles();

  const day = holiday.date ? holiday.date.split("-")[2] : "";

  return (
    <Box className={classes.row}>
      <Typography className={classes.dateLabel}>{day}</Typography>
      <Typography className={classes.nameLabel} component="div">
        <span>{holiday.name}</span>
        {holiday.isNational === false && (
          <Chip
            size="small"
            label={i18n.t("feriados.customBadge")}
            className={classes.customChip}
            variant="outlined"
          />
        )}
      </Typography>
      <Box className={classes.switchGroup}>
        <Typography className={classes.switchLabel}>Ativo</Typography>
        <Switch
          size="small"
          checked={holiday.active}
          onChange={(e) => onToggleActive(holiday.id, e.target.checked)}
          color="primary"
        />
        <Typography className={classes.switchLabel}>Fechar atendimento</Typography>
        <Switch
          size="small"
          checked={holiday.closeTicket}
          onChange={(e) => onToggleCloseTicket(holiday.id, e.target.checked)}
          color="secondary"
        />
      </Box>
    </Box>
  );
};

export default HolidayRow;
